// Deliberately not memoized: DeckOverlay needs frequent re-renders to track the Google Maps overlay lifecycle.
import React from 'react'

import { useWebGLSupport } from 'components/common/map/webgl/useWebGLSupport'
import WebGLMarkerSurface from 'components/common/map/webgl/WebGLMarkerSurface'
import ServiceMapMarkers from 'components/configured-service/Schedule/ServiceMapMarkers'
import { ServiceMarkerCanvasProps } from 'components/configured-service/Schedule/types'
import WebGLServiceMarkerLayer from 'components/configured-service/Schedule/WebGLServiceMarkerLayer'

const AdaptiveServiceMarkerLayer = ({
  markers,
  mapMarkerType,
  activeMarker,
  selectedDaysMap,
  selectedRoutesMap,
  onMouseEnter,
  onMouseLeave,
  onClick,
  radiusCircle,
  centerMarker,
  selectedIds,
  // Fades rather than filters — dropping a pin is what `selectedDaysMap` already does.
  dimmedIds,
  // Pin diameter in pixels; omitted takes the shared default.
  iconSize,
}: ServiceMarkerCanvasProps) => {
  const webglSupported = useWebGLSupport()

  const domMarkers = (
    <ServiceMapMarkers
      activeMarker={activeMarker}
      dimmedIds={dimmedIds}
      iconSize={iconSize}
      mapMarkerType={mapMarkerType}
      markers={markers}
      selectedDaysMap={selectedDaysMap}
      selectedRoutesMap={selectedRoutesMap}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )

  return (
    <WebGLMarkerSurface componentName="AdaptiveServiceMarkerLayer" enabled={webglSupported} fallback={domMarkers}>
      <WebGLServiceMarkerLayer
        activeMarker={activeMarker}
        centerMarker={centerMarker}
        dimmedIds={dimmedIds}
        iconSize={iconSize}
        mapMarkerType={mapMarkerType}
        markers={markers}
        radiusCircle={radiusCircle}
        selectedDaysMap={selectedDaysMap}
        selectedIds={selectedIds}
        selectedRoutesMap={selectedRoutesMap}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </WebGLMarkerSurface>
  )
}

export default AdaptiveServiceMarkerLayer
